module.exports = __webpack_public_path__ + "img/happy_easter.3e71659d.svg";